import { useContext } from 'react'
import { AuthContext } from '../provider/auth'
import { Outlet, useLocation } from 'react-router-dom'
import { Navigate } from 'react-router'
import { useAtomValue } from 'jotai'
import { isShowShippingTestsEnabledAtom } from '../store/featureFlags.atoms'

export const ProtectedRoute = () => {
  const auth = useContext(AuthContext)
  const location = useLocation()

  if (!auth.isLogged) {
    return <Navigate to={`/login`} state={{ backTo: location.pathname }} />
  }

  return <Outlet />
}

export const ShippingTestsRoute = () => {
  const isEnabled = useAtomValue(isShowShippingTestsEnabledAtom)
  if (!isEnabled) return <Navigate to="/tests" replace />
  return <Outlet />
}
